import { useIntl } from 'react-intl'
import LineClockIcon from 'LuxKit/Icons/line/LineClockIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  className?: string
}

function OfferTimeLimitedText({ className }: Props) {
  const intl = useIntl()

  return (
    <BodyTextBlock variant="medium" weight="bold" className={className} startIcon={<LineClockIcon className="highlight" />}>
      {intl.formatMessage({
        id: 'zFI9B4zpdfbVOemp8h9O',
        defaultMessage: 'Time limited offer',
        description: 'Label indicating the offer is available for a limited time',
      })}
    </BodyTextBlock>
  )
}

export default OfferTimeLimitedText
